ACC.account = {

	_autoload: [
		["swap",$(".page-account .myaccount-page").length > 0 || $(".page-my-company .myaccount-page").length > 0],
		"checkSupportTicketForm",
		"accountTvaForm",
		"viewMyAccountPageBanner",
		"clickMyAccountPageBanner",
		"viewPromoBanner",
		["directDebitForm", $('#directDebitForm').length > 0],
		"bindDeliveryDetailsPopin"
	],

	orderImgDesktop: "",

	swap: function() {
		$container = $(".myaccount-page");
		$firstRow = $container.find("> .row.first");
		$secondRow =  $container.children(".row:eq(1)");
		$swapped = false;

		$(window).on("load resize", function() {
			if($(window).width() < 640) {
				if(!$swapped) {
					ACC.account.swapMobile();
					$swapped = true;
				}
			}	else {
				if($swapped) {
					ACC.account.revertChanges();
					$swapped = false;
				}
			}
		});
	},

	swapMobile: function() {
		$(".myaccount-page").addClass("myaccount-mobile");

		$topEmpty = $firstRow.find(".myaccount-page-col-1 div:eq(0)");
		$documents = $firstRow.find(".myaccount-page-col-2 .row > div:eq(0)");
		$bottomEmpty = $secondRow.find(".myaccount-page-col-1 div:eq(0)");
		$cart = $secondRow.find(".myaccount-page-col-2 .row > div:eq(0)");
		$password = $secondRow.find(".myaccount-page-col-2 .row > div:eq(1)");
		$orders = $secondRow.find(".myaccount-page-col-1 div:eq(1)");
		$ordersImg = $orders.find("img");

		$documents.insertAfter($topEmpty);
		$cart.insertAfter($orders);
		$orders.insertAfter($password);
		$password.insertBefore($cart);

		ACC.account.orderImgDesktop = $ordersImg.attr("src");
		$ordersImg.attr("src", $ordersImg.data("mobileSrc"));

	},

	revertChanges: function() {
		$(".myaccount-page").removeClass("myaccount-mobile");

		$documents = $firstRow.find(".myaccount-page-col-1 div:eq(1)");
		$faq = $firstRow.find(".myaccount-page-col-2 .row > div");
		$cart = $secondRow.find(".myaccount-page-col-1 > div:eq(2)");
		$password = $secondRow.find(".myaccount-page-col-1 > div:eq(1)");
		$orders = $secondRow.find(".myaccount-page-col-2 > .row > div");
		$ordersImg = $orders.find("img");

		$documents.insertBefore($faq);
		$cart.insertAfter($orders);
		$orders.insertAfter($password);
		$password.insertAfter($cart);
		$ordersImg.attr("src", ACC.account.orderImgDesktop);

	},

	checkSupportTicketForm :function(){
		$("#supportTicketForm").on('submit', function(e){
			e.preventDefault();
			if($('#createTicket-subject').val() && !$('#createTicket-subject').val().length){
				setTimeout(function(){
					$('#addTicket').prop('disabled',true);
					$('#createTicket-subject').parent().addClass('has-error');
				},ACC.config.timeToActivateButtons);
			}
		})

	},
	
	accountTvaForm: function(){
		$('#num-tva').keyup(function(){
		    $(this).val($(this).val().toUpperCase());
		});
	},

	viewMyAccountPageBanner: function (){
		if ($(".page-account .banner__component--responsive").length > 0) {
			var bannerName = $('.page-account .banner__component--responsive').data('banner-name');
			ACC.track.accountBannerViewEvent(bannerName);
		}
	},

	clickMyAccountPageBanner: function(){
		$(document).on('click', '.page-account .banner__component--responsive a', function () {
			var bannerName = $('.page-account .banner__component--responsive').data('banner-name');
			ACC.track.accountBannerClickEvent(bannerName);
		});
	},

	viewPromoBanner : function (){
		if ($(".coupons-bloc").length > 0){
			ACC.track.trackPromoBanner();
		}
	},
	directDebitForm: function () {
		const $fields = {
			formFields: $('#formFields'),
			email: $('#email'),
			iban: $('#iban'),
			bic: $('#bic'),
			mobile: $('#phone-mobile'),
			terms: $('#conditions'),
			submitBtn: $('#submitBtn'),
			radios: $('input[name="mandateToBeSignedByLoggedInUser"]')
		};

		let submitted = false;

		// === validators ===
		const validators = {
			'#email': {
				validate: () => !$fields.email.is(':visible') || new RegExp(emailRegex).test($fields.email.val()?.trim() || ''),
				message: errorsMsg.email.notvalid
			},
			'#iban': {
				validate: () => new RegExp(ibanRegex).test($fields.iban.val()?.trim() || ''),
				message: errorsMsg.all.notvalid
			},
			'#bic': {
				validate: () => new RegExp(bicRegex).test($fields.bic.val()?.trim() || ''),
				message: errorsMsg.all.notvalid
			},
			'#phone-mobile': {
				validate: () => /^(\+|\d)[0-9]{7,16}$/.test($fields.mobile.val()?.trim() || ''),
				message: errorsMsg.all.mandatory
			},
			'#conditions': {
				validate: () => $fields.terms.is(':checked'),
				message: errorsMsg.all.mandatory
			}
		};

		function showError(selector, message) {
			const $field = $(selector).closest('.amds-form-field');
			$field.find('.amds-form-field__errormsg').html(message || '');
			$field.addClass('has-error');
		}

		function clearErrors() {
			$('.amds-form-field__errormsg').empty();
			$('.amds-form-field').removeClass('has-error');
		}

		function clearValues() {
			$('#directDebitForm .amds-form-field__input').val('');
		}

		function validateField(selector) {
			const value = $(selector).val() || "";
			const $field = $(selector).closest('.amds-form-field');

			if (value.length === 0) {
				$field.find('.amds-form-field__errormsg').empty();
				$field.removeClass('has-error');
				return false;
			}

			const { validate, message } = validators[selector];
			const valid = validate();

			if (!valid) {
				showError(selector, message);
			} else {
				$field.find('.amds-form-field__errormsg').empty();
				$field.removeClass('has-error');
			}

			return valid;
		}

		function updateSubmitState() {
			const isValid = Object.keys(validators).every(selector => {
				if (selector === '#email' && $fields.email.hasClass('hidden')) return true;
				return validateField(selector);
			});
			$fields.submitBtn.prop('disabled', !isValid);
			return isValid;
		}

		function showOrHideEmail(value) {
			$fields.email.toggleClass('hidden', value !== 'false');
		}

		function showFormFieldsIfNeeded() {
			const selectedValue = $fields.radios.filter(':checked').val();
			if (selectedValue) {
				$fields.formFields.removeClass('hidden');
				showOrHideEmail(selectedValue);
			}
		}

		showFormFieldsIfNeeded();

		$fields.radios.on('change', () => {
			clearErrors();
			clearValues();
			showFormFieldsIfNeeded();
			updateSubmitState();
		});

		$(document).ready(function () {
			clearValues();
			clearErrors();
		});

		Object.keys(validators).forEach(selector => {
			$(selector).on('input change', () => {
				validateField(selector);
				updateSubmitState();
			});
		});

    	// Submit
		$fields.submitBtn.on('click', function (e) {
			e.preventDefault();
			submitted = true;

			clearErrors();
			if (updateSubmitState()) {
				$('.modal-loader').show();
			}
		});
	},
	bindDeliveryDetailsPopin() {
		$(document).on("click", ".js-order-delivery-contact", function (e) {
            e.preventDefault();
            ACC.account.contactAgency();

            const $this = $(this);
            const mailItem = $this.siblings(".mailItem").text().trim() || $this.data("mailitem");
			const pathParts = window.location.pathname.split('/').filter(Boolean);
			const poNumber = pathParts[pathParts.length - 1];

            $("#wrapperContactAgency #contactAgency #email").val(mailItem);
            $("#wrapperContactAgency #contactAgency input#code").val(poNumber);
        });
	},
	contactAgency: function () {
        var title = $('#wrapperContactAgency').data("cancelTitle");
		const pathParts = window.location.pathname.split('/').filter(Boolean);
		const poNumber = pathParts[pathParts.length - 1];
        ACC.colorbox.open("", {
            href: "#wrapperContactAgency",
            inline: true,
            width: "600px",
			height: "430px",
			overlayClose: false,
			onOpen: function () {
				//used to prevent input value reset after overlay click!
				$('#cboxOverlay').remove();
				$('body').append('<div id="cboxNewOverlay" style="opacity: 0.7; visibility: visible;"></div>');
				$('#cboxNewOverlay').css({
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					background: 'rgba(0,0,0,0.7)',
					zIndex: 9998,
					overflow: "hidden",
					opacity: "1"
				});
				$('#cboxNewOverlay').off('click');
			},
            onComplete: function () {
                $(document).off("submit", "#contactAgency").on("submit", '#contactAgency', function (e) {
					e.preventDefault();
                    var $form = $('#wrapperContactAgency .formContactAgency');
                    $.ajax({
                        url: $form.attr("action"),
                        data: $form.serialize(),
                        type: $form.attr("method") ? $form.attr("method").toUpperCase() : "GET",
                        success: function () {
                            var url = ACC.config.encodedContextPath + "/my-account/delivery-details/" + poNumber
                            window.location.replace(url);
                        },
                        error: function () {
                          alert("Failed");
                        }
                    });
                    return false;
                });
            },
			onClosed: function() {
				$('#cboxNewOverlay').remove();
			}
        });
    },
};
